import React, { useEffect, useRef } from 'react';
import './style.css';
import {ReactComponent as Girl1} from '../../assets/images/yellow-girl.svg';
import {ReactComponent as Girl2} from '../../assets/images/our-options-girl2.svg';
import {ReactComponent as Boy} from '../../assets/images/our-options-boy.svg';
import {ReactComponent as MBoy} from '../../assets/images/mour-options-boy.svg';
import {ReactComponent as MGirl1} from '../../assets/images/mour-options-girl.svg';

import {ReactComponent as VR} from '../../assets/images/our-options-vr.svg';
import {ReactComponent as MVR} from '../../assets/images/mour-options-vr.svg';
import {ReactComponent as OfficeSpace} from '../../assets/images/our-options-office-space.svg';
import {ReactComponent as MOfficeSpace} from '../../assets/images/mour-options-office-space.svg';
import {ReactComponent as Chair} from '../../assets/images/chair1.svg';
import {ReactComponent as MChair} from '../../assets/images/mchair.svg';

import {gsap, ScrollTrigger, MotionPathPlugin } from 'gsap/all';

export default function OurOptions() {
  let ourOptionRef = useRef(null);
  let girl1Ref = useRef(null);
  let girl2Ref = useRef(null);
  let tableRef = useRef(null);
  let bgRef = useRef(null);
  let boyRef = useRef(null);
  let chairRef = useRef(null);

  let height = window.innerHeight + 200 + 'px';
  useEffect(() => {
    if(window.innerWidth>=769 )
    {    
      gsap.fromTo(ourOptionRef.current.childNodes,
    {
      opacity: 1,
      visibility: 'none',
      y: '20px',
      // lineHeight: 0
    },
    {
      scrollTrigger: {
        // trigger: ourOptionRef.current,
        start: '+4980px 50%',
        end: '+4980px 18%',
        //  markers: true,
        scrub: true,
        // pin: true,
      },
      // visibility: 'visible',
      opacity: 1,
      stagger: 0.3,
      y: '0px',
      duration: 0.6,
      lineHeight: '60px'
    });

    gsap.to(ourOptionRef.current, {
      scrollTrigger: {
        trigger: ourOptionRef.current,
        scrub: true,
        // markers:true,
      },
      y: -300,
      // x: 100
    });

    gsap.to(girl1Ref.current, {
      scrollTrigger: {
        trigger: ourOptionRef.current,
        scrub: true,
      },
      y: -230,
      x: 100
    });
    gsap.to(bgRef.current, {
      scrollTrigger: {
        trigger: ourOptionRef.current,
        scrub: true,
      },
      y: -230,
      x: -70
    });
    gsap.to(chairRef.current, {
      scrollTrigger: {
        trigger: ourOptionRef.current,
        scrub: true,
      },
      y: -50,
      x: -10,
      transform: 'rotate(90deg)'
    });

    gsap.to(boyRef.current, {
      scrollTrigger: {
        trigger: ourOptionRef.current,
        scrub: true,
      },
      y: -50,
      x: -100,
    });

    gsap.to(tableRef.current, {
      scrollTrigger: {
        trigger: ourOptionRef.current,
        scrub: true,
      },
      y: -50,
      x: -50,
      transform: 'scale(1.02)'
    });

    gsap.to(girl2Ref.current, {
      scrollTrigger: {
        trigger: ourOptionRef.current,
        scrub: true,
      },
      y: -50,
      x: -50,
      transform: 'scale(1.1)'
    });
  }
  }, []);

  return (
    <div 
      style={{zIndex: '2', height}}
      className='our-option flex w-full flex-col items-center justify-center min-h-screen relative'>
      <div ref={ourOptionRef} className="block options-wrapper z-10 mt-24 sm:mt-0 sm:hidden">
        <h1 className="options-heading main-font text-4xl sm:text-6xl">Hey, makes your design projects easy and enjoyable.</h1>
        {/* <h1 className="options-heading main-font text-4xl sm:text-6xl">design projects</h1>
        <h1 className="options-heading main-font text-4xl sm:text-6xl">easy and enjoyable.</h1> */}
        <p className="md:w-4/6 mx-auto mt-5 options-para secondary-font font-light lg:text-2xl sm:text-lg leading-6 ">
          It’s cool, trendy, artistic illustrations and some simple steps can bring your concepts to life.
        </p>
      </div>
      <div ref={ourOptionRef} className="hidden options-wrapper z-10 mt-24 sm:mt-0 sm:block">
        <h1 className="options-heading main-font text-4xl sm:text-6xl">Hey, makes your</h1>
        <h1 className="options-heading main-font text-4xl sm:text-6xl">design projects easy</h1>
        <h1 className="options-heading main-font text-4xl sm:text-6xl">and enjoyable.</h1>
        <p className="md:w-4/6 mx-auto mt-5 options-para secondary-font font-light lg:text-2xl sm:text-lg leading-6 ">
          It’s cool, trendy, artistic illustrations and some simple steps can bring your concepts to life.
        </p>
      </div>
      <div
        style={{zIndex: '3', height}}
        className='parllax-elements-wrapper absolute top-0 left-0 w-full'>
          <div></div>
           <VR 
            ref={bgRef} 
            className='hidden sm:block absolute ' 
            style={{top: '250px', left: '-10px'}}
          /> 
           <MVR 
            className='sm:hidden absolute' 
            style={{top: '97px'}}
          /> 
          <Girl1 
            ref={girl1Ref} 
            className='hidden sm:block absolute sm:ml-20'
          />
          <MGirl1 
            className='sm:hidden absolute ml-4'
            style={{top: '30px'}}
          />
          <OfficeSpace 
            ref={tableRef} 
            className='hidden sm:block absolute right-0 bottom-0'
          />
          <MOfficeSpace 
          style={{top:"430px"}}
            className='sm:hidden absolute right-0'
          />
          <Girl2 
            ref={girl2Ref} 
            className='absolute bottom-0 right-0 mgirl2'
          />
          <Boy 
            ref={boyRef} 
            className='hidden sm:block absolute top-0 right-0'
          />
           <MBoy 
            className='sm:hidden absolute top-0 right-0'
            style={{top: '95px'}}
          />
          <Chair 
            ref={chairRef} 
            className='absolute hidden sm:block bottom-0 left-0 transform' 
            // style={{transform: 'scaleX(1)'}}
          />
          <MChair 
            className='sm:hidden absolute bottom-0 left-0 transform' 
             style={{bottom: '365px'}}
          />
      </div>
    </div>
  )
}